import { TranslatePipe } from '@ngx-translate/core';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input
} from '@angular/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { WINDOW } from '@shared/providers';
import { navigateToUrl } from '@shared/utils';

@Component({
  selector: 'moxi-ui-page-actions',
  imports: [TranslatePipe, NzButtonModule, NzIconModule],
  templateUrl: './page-actions.component.html',
  styleUrl: './page-actions.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageActionsComponent {
  private readonly window = inject(WINDOW);

  showBackButton = input<boolean>();
  backButtonUrl = input<string | undefined>();
  showTitle = input<boolean>(true);
  titleI18nKey = input<string | undefined>();

  isBackBtnVisible = computed(
    () => this.showBackButton() && (this.backButtonUrl() || this.hasBackButton)
  );

  isTitleVisible = computed(() => this.showTitle() && !!this.titleI18nKey);

  hasBackButton = this.window.history.length > 1;

  onBackEvent(): void {
    if (this.hasBackButton) {
      this.window.history.back();
    }

    if (this.backButtonUrl()) {
      navigateToUrl(this.backButtonUrl());
    }
  }
}
